<script setup lang="ts">
import { ref, onMounted } from "vue";
import PerduView from "@/components/PerduView.vue";
import WinView from "@/components/WinView.vue";
import Win2View from "@/components/Win2View.vue";
const status = ref("PERD");
const urlParams = ref(new URLSearchParams(window.location.search));

onMounted(async () => {
  try {
    if (
      urlParams.value.get("status") === "GAGNE" ||
      urlParams.value.get("status") === "WIN2" ||
      urlParams.value.get("status") === "PERD"
    ) {
      status.value = urlParams.value.get("status");
    } else {
      if (sessionStorage.getItem("status") == "DEJA") {
        status.value = "PERD";
      } else {
        status.value = sessionStorage.getItem("status") || "PERD";
      }
    }

    // console.log(status.value);
  } catch (e) {
    console.error(e);
  }
});
</script>
<template>
  <PerduView v-if="status === 'PERD'" />
  <WinView v-else-if="status === 'GAGNE'" />
  <Win2View v-else-if="status === 'WIN2'" />
</template>
